export const enum RecaptchaAction {
    Login = 'login',
    ResetPassword = 'reset_password',
    ResetPasswordToken = 'reset_password_token',
    Register = 'register',
    UserExists = 'user_exists'
}
